import {EAppTypes, IAppState, TAppActionTypes} from 'models';

const initialState: IAppState = {
    connectionIssue: false,
    data: {
        timezones: undefined,
    },
    loading: false,
    appVisibility: {
        isVisible: true,
        visibilityState: 'visible',
    },
};

const appReducer = (
    state = initialState,
    action: TAppActionTypes,
): IAppState => {
    switch (action.type) {
        case EAppTypes.APP_META_DATA_TIMEZONES_SET: {
            return {
                ...state,
                data: {
                    timezones: action.payload,
                },
            };
        }
        case EAppTypes.APP_SET_CONNECTION_ISSUE_ACTION: {
            return {
                ...state,
                connectionIssue: action.payload,
            };
        }
        case EAppTypes.APP_LOADING_ACTION: {
            return {
                ...state,
                data: {
                    ...state.data,
                },
                loading: action.payload,
            };
        }
        case EAppTypes.APP_SET_VISIBILITY_ACTION: {
            return {
                ...state,
                appVisibility: action.payload,
            };
        }

        default:
            return state;
    }
};

export default appReducer;
